// Service file that handle api client and there methods
import axios from "axios";
// storage instance
import StorageService from "@Vytelle/admin/src/services/StorageService";
// constants
import {
  API_TIMEOUT,
  APPLICATION_ID,
} from "@Vytelle/admin/src/constants/General";

// Helper
import { getBaseUrl } from "@Vytelle/admin/src/helpers/GeneralHelper";

export const apiClient = () => {
  const token = StorageService?.instance?.getAccessToken();

  // Dummy Condition, will remove with actual api
  let defaultOptions = !!token
    ? {
        headers: {
          Authorization: token ? `Bearer ${token || null}` : "",
          "Content-Type": "application/json",
          "X-ApplicationIDHeader": APPLICATION_ID,
        },
      }
    : {
        headers: {
          "Content-Type": "application/json",
          "X-ApplicationIDHeader": APPLICATION_ID,
        },
      };

  // Request timeout
  defaultOptions = {
    ...defaultOptions,
    timeout: API_TIMEOUT,
  };

  return {
    get: (url, options = {}) =>
      axios.get(`${getBaseUrl(url)}${url}`, { 
        ...defaultOptions, 
        ...options,
        headers: !!options?.headers? options.headers: defaultOptions.headers
      }),
    post: (url, data, options = {}) =>
      axios.post(`${getBaseUrl(url)}${url}`, data, {
        ...defaultOptions,
        ...(options?.['X-ApplicationIDHeader'] && { headers: { ...defaultOptions.headers, 'X-ApplicationIDHeader': options['X-ApplicationIDHeader'] } }),
        ...options,
      }),
    put: (url, data, options = {}) =>
      axios.put(`${getBaseUrl(url)}${url}`, data, {
        ...defaultOptions,
        ...(options?.['X-ApplicationIDHeader'] && { headers: { ...defaultOptions.headers, 'X-ApplicationIDHeader': options['X-ApplicationIDHeader'] } }),
        ...options,
      }),
    patch: (url, data, options = {}) =>
      axios.patch(`${getBaseUrl(url)}${url}`, data, {
        ...defaultOptions,
        ...options,
      }),
    delete: (url, data, options = {}) =>
      axios.delete(`${getBaseUrl(url)}${url}`, {
        ...defaultOptions,
        ...options,
        data,
      }),
  };
};
